export const global = {
  orderBumps: document.getElementById("order-bumps-content"),
  miniCart: document.getElementsByClassName("mini-cart-init"),
  cart: document.getElementsByClassName("cart-wrapper"),
  checkoutPricesSummary: document.getElementsByClassName(
    "woocommerce-checkout-review-order-table"
  ),
  checkoutShippingLabels: document.getElementsByClassName(
    "shipping-method-label"
  ),
  cartItemsCount: document.getElementsByClassName("cart-items-count"),
  noticeWrapper: document.querySelector(".notice-modal-wrapper"),

  getBlocksToUpdate() {
    let blocksToUpdate = [];

    if (this.orderBumps) {
      blocksToUpdate.push("orderBumps");
    }

    if (this.miniCart.length > 0) {
      blocksToUpdate.push("miniCart");
    }

    if (this.cart.length > 0) {
      blocksToUpdate.push("cart");
    }

    if (this.checkoutPricesSummary.length > 0) {
      blocksToUpdate.push("checkoutPricesSummary");
    }

    if (this.checkoutShippingLabels.length > 0) {
      blocksToUpdate.push("checkoutShippingLabels");
    }

    return blocksToUpdate;
  },

  updateBlocks(response) {
    if (response.orderBumps && global.orderBumps) {
      global.orderBumps.innerHTML = response.orderBumps;
    }

    if (response.miniCart && this.miniCart.length > 0) {
      this.miniCart[0].outerHTML = response.miniCart;
    }

    if (response.cart && this.cart.length > 0) {
      this.cart[0].outerHTML = response.cart;
    }

    if (
      response.checkoutPricesSummary &&
      this.checkoutPricesSummary.length > 0
    ) {
      this.checkoutPricesSummary[0].outerHTML = response.checkoutPricesSummary;
    }

    if (
      response.checkoutShippingLabels &&
      this.checkoutShippingLabels.length > 0
    ) {
      Array.from(this.checkoutShippingLabels).forEach(function (
        checkoutShippingLabel,
        index
      ) {
        checkoutShippingLabel.outerHTML =
          response.checkoutShippingLabels[index];
      });
    }

    if (response.cartItemsCount && this.cartItemsCount.length > 0) {
      Array.from(this.cartItemsCount).forEach(function (cartItemsCount) {
        cartItemsCount.classList.remove("d-none");
        cartItemsCount.innerHTML = response.cartItemsCount;
      });
    }
  },

  appendNotice(notice) {
    if (!this.noticeWrapper || this.noticeWrapper.length < 1) {
      return;
    }

    const noticeBlock = this.noticeWrapper.querySelector(".notice-block");

    if (!noticeBlock || noticeBlock.length < 1) {
      return;
    }

    this.noticeWrapper.addEventListener("click", function () {
      let noticeWrapper = document.querySelector(".notice-modal-wrapper");

      if (noticeWrapper.classList.contains("d-none")) {
        return;
      }

      noticeWrapper.classList.add("d-none");
    });

    noticeBlock.innerHTML = notice;

    this.noticeWrapper.classList.remove("d-none");

    setTimeout(
      function (noticeWrapper) {
        if (noticeWrapper.classList.contains("d-none")) {
          return;
        }

        noticeWrapper.classList.add("d-none");
      },
      2000,
      this.noticeWrapper
    );
  },
};
